import { CLIENT_URL } from "./Constants/URL";

//TMAX

// const config = {
//     appId: 'bf6d079a-bddd-4e9a-bcfa-59448c380e7c',
//     tenantId: "c8ccf83d-0359-4ee4-88cf-37b0e12bb7b1",
//     redirectUri: CLIENT_URL,
//     scopes: [
//         'user.read',
//     ]
// };

//Byrne
const config = {
    appId: 'c1dcf1ac-576e-4be3-9412-db0f09dd2f2c',
    tenantId: "f969ed16-85ac-4e71-94ff-8eb7c695a0de",
    redirectUri: CLIENT_URL,
    scopes: [
        'user.read',
    ]
};



export default config;